import { useState } from 'react'

import { OrderableList, LegacyPage, Json } from 'peach/components'
import KeyboardOrderableList from 'peach/components/List/KeyboardOrderableList'

const defaultValue = ['One', 'Two', '3', 'Four', 'five']

const ScratchOrderable = () => {
  const [state, setState] = useState()

  return (
    <LegacyPage.Centered>
      <Json.Table json={{ state, defaultValue }} title='State' />
      <OrderableList
        add
        defaultValue={defaultValue}
        label='An Ordered List'
        note='Use arrow keys to move items up and down multiple rows quickly'
        onChange={setState}
        remove
        value={state}
      />

      <KeyboardOrderableList
        add
        defaultValue={defaultValue}
        label='A  New Ordered List'
        note='Use arrow keys to move items up and down multiple rows quickly'
        onChange={setState}
        remove
        value={state}
      />
    </LegacyPage.Centered>
  )
}

export default ScratchOrderable
